import { useParams, Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import LoadingPage from '@/components/common/LoadingPage';
import Error from '@/components/common/Error';

import EditActivityForm from './EditActivityForm';

import { useActivity } from '@/data/activity';

const EditActivityPage = () => {
  const params = useParams();
  const activity = useActivity(params.id);

  if (activity.isLoading && !activity.data) {
    return <LoadingPage />;
  }

  if (activity.error) {
    return <Error error="There was an error loading the activity" />;
  }

  return (
    <div className="max-w-6xl mx-auto">
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/activity">Activities</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{activity.data.title}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            Edit {activity.data.title}
          </CardTitle>
          <CardDescription>Edit {activity.data.title} details</CardDescription>
        </CardHeader>
        <CardContent>
          <EditActivityForm />
        </CardContent>
      </Card>
    </div>
  );
};

export default EditActivityPage;
